import {PrimaryButton} from '@/shared-components/Button'
import {EmailCustomStepType} from '@/types/NotificationStep'
import {useIntl} from 'react-intl'

interface Props {
  notificationTypeName: string
  emailStep: EmailCustomStepType
}

export default function NotificationEmailDetails({notificationTypeName, emailStep}: Props): React.JSX.Element {
  const {formatMessage} = useIntl()
  const imgSrc = emailStep.selectedImage?.url || 'https://upload.wikimedia.org/wikipedia/commons/a/a6/PepsiCo_logo.svg'

  return (
    <div data-testid="notification-email-details" className="mt-2 rounded-lg border border-dashed border-blue-500 p-4">
      <div className="mt-8 text-base font-bold text-text-primary">
        {formatMessage({id: 'NOTIFICATION_DETAILS.NOTIFICATION_DETAILS_SECTION_TITLE'})}
      </div>
      <div className="border-b border-border-gray">
        <div className="pt-3 text-xs font-bold text-text-secondary">
          {formatMessage({id: 'NOTIFICATION_DETAILS.NOTIFICATION_TYPE'})}
        </div>
        <div className="pb-3 pt-1 text-xs text-text-primary">{notificationTypeName}</div>
      </div>

      <div className="pt-3 text-sm font-bold text-text-primary">{emailStep.emailSubject}</div>
      <div className="pb-2 pt-2">
        <img src={imgSrc} />
      </div>
      <div className="mt-4 text-sm text-text-primary">{emailStep.emailMessage}</div>
      <div className="mt-4">
        <PrimaryButton
          size="large"
          data-cy="button-go-to-page"
          data-testid="button-go-to-page"
          onClick={() => {}}
          className="flex w-full justify-center"
        >
          {formatMessage({id: 'NOTIFICATION_DETAILS.GO_TO_PAGE_BUTTON'})}
        </PrimaryButton>
      </div>
    </div>
  )
}
